import { Box, Button, styled } from '@mui/material';

interface ButtonWrapperStyledProps {
  $isThird: boolean;
}

export const LifeEventContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#ffffff',
  boxShadow: '0px 1px 10px 0px #0000003D',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'auto',
  },
}));

export const LifeEventBodyContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  padding: '36px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const LifeEventButtonContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const LifeEventButtonWrapperStyled = styled(
  Box
)<ButtonWrapperStyledProps>(({ $isThird, theme }) => ({
  width: '188px',
  height: '67px',
  margin: $isThird ? '17px 0px 0px 0px' : '17px 17px 0px 0px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'black !important',
  [theme.breakpoints.down('sm')]: {
    margin: '17px 0px 0px 0px',
  },
}));

export const LifeEventButtonStyled = styled(Button)({
  width: '100%',
  height: '67px',
  border: '1px solid #D9D9D9',
  borderRadius: '4px',
  padding: '0px 8px',
  fontWeight: '400',
  fontSize: '16px',
  color: '#000000',
  whiteSpace: 'normal',
  '&:hover': {
    backgroundColor: '#E6E6E6',
  },
});
